import { ChipButton } from '~/shared/components/buttons/ChipButton';
import { getDisciplineIntent } from '~/libraries/disciplines/util';
import type { ButtonProps } from '~/shared/components/buttons/Button';

export function DisciplineChipButton({
	id,
	abbreviation,
	selected,
	...props
}: { id: number; abbreviation: string; selected?: boolean } & Omit<ButtonProps, 'id'>) {
	return <ChipButton appearance={selected ? 'solid' : 'outline'} intent={getDisciplineIntent(id)} label={abbreviation} {...props} />;
}
